export const gameName = "KheloWin";

export const gameCollectionArray = [
	{
		id: 1,
		label: "Spin 2 Win",
		value: "spin2win",
		logo: "/spin2win.png",
		api: "zerotonine",
	},
	{
		id: 2,
		label: "Joker 12 Card",
		value: "joker12card",
		logo: "/12card.png",
		api: "card12",
	},
	{
		id: 3,
		label: "16 Card",
		value: "joker16card",
		logo: "/16card.png",
		api: "card16",
	},
	{
		id: 4,
		label: "Triple Chance",
		value: "triplechance",
		logo: "/16card.png",
		api: "triplechance",
	},
	// {
	//     label: "Double Chance",
	//     value: "doubleChance",
	//     logo: "/doublechance.png",
	// },
];

export const gamePorts = {
	spin2win: "3042",
	joker12card: "3043",
	joker16card: "3044",
	triplechance: "3041",
};

export const gamePayRates = {
	spin2win: 9,
	joker12card: 10,
	joker16card: 14,
};

export const cardArray = [
	{ id: 1, name: "JC", nCardId: "N8" },
	{ id: 2, name: "JD", nCardId: "N9" },
	{ id: 3, name: "JS", nCardId: "N10" },
	{ id: 4, name: "JH", nCardId: "N11" },
	{ id: 5, name: "QC", nCardId: "N4" },
	{ id: 6, name: "QD", nCardId: "N5" },
	{ id: 7, name: "QS", nCardId: "N6" },
	{ id: 8, name: "QH", nCardId: "N7" },
	{ id: 9, name: "KC", nCardId: "N0" },
	{ id: 10, name: "KD", nCardId: "N1" },
	{ id: 11, name: "KS", nCardId: "N2" },
	{ id: 12, name: "KH", nCardId: "N3" },
	{ id: 13, name: "AC", nCardId: "N12" },
	{ id: 14, name: "AD", nCardId: "N13" },
	{ id: 15, name: "AS", nCardId: "N14" },
	{ id: 16, name: "AH", nCardId: "N15" },
];

export const userLevelArray = [
	{ level: 5, name: "User" },
	{ level: 4, name: "Agent" },
	{ level: 3, name: "Master" },
	{ level: 2, name: "Stokist" },
	{ level: 1, name: "Super Stokist" },
	{ level: 0, name: "Super Admin" },
];

export const rootDomain = "99khelojeeto.in";

export const portSubdomainMap = {
	3040: "api",
	3041: "triplechance",
	3042: "spin2win",
	3043: "joker12card",
	3044: "joker16card",
};
